<ng-container *ngIf="items$ | async as items">
  <div class="container js-highlighted-product" [attr.data-name]="title$ | async">
    <label [ngClass]="activeLanguage$ | async">{{ title$ | async }}</label>
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" *ngIf="items.length > 0" [config]="slickConfig">
      <div ngxSlickItem *ngFor="let item of items; let i = index" class="slide">
        <div
          class="item"
          [class.has-erp-promo]="atLeastOneHasErpPromo"
          [class.has-hybris-promo]="atLeastOneHasHybrisPromo"
          *ngIf="item | async as data"
        >
          <a tabindex="0" (click)="goToPdp(data, $event, i + 1)">
            <span #prodImageElement [style.height.px]="size" class="prod-image product-carousel-image">
              <cx-media
                [style.height.px]="size"
                [style.background-size.px]="size"
                [container]="getImageRendition(data?.images?.PRIMARY)"
                format="product"
                [class.is-missing-fish]="businessType === 'fish'"
              >
              </cx-media>
            </span>
            <span class="prod-sku">
              {{ data.code }}
            </span>
            <span class="prod-name" [innerHTML]="data.name"></span>
            <span class="prod-price">
              <ng-template [ngIf]="!showSrp">
                <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
                <span class="p-price" [class.erp-promo]="erpPromoValue(data?.code) && erpPromoValue(data?.code) !== ''">
                  <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(data.code); else dealerPriceReady">
                    <ng-container *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
                      <div class="spinner-shimano" *ngIf="hasDealerPrice">
                        <div></div>
                      </div>
                      <div
                        class="no-dealer-price no-dealer-price-hp"
                        *ngIf="!hasDealerPrice && !tooltipIconConfig?.enabled; else noDealerPriceTooltip"
                      ></div>
                      <ng-template #noDealerPriceTooltip>
                        <app-tooltip-icon
                          *ngIf="!hasDealerPrice && tooltipIconConfig?.enabled"
                          [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                          dealerPriceIconContainerClass="no-dealer-price-hp"
                          [uniqueClass]="data?.code"
                          placement="bottom-right"
                          [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                          [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                          [noPointerEventsOnElement]="tooltipIconConfig?.noPointerEventsOnElement"
                          [handleEvents]="tooltipIconConfig?.handleEvents"
                        ></app-tooltip-icon>
                      </ng-template>
                    </ng-container>
                  </div>
                  <ng-template #dealerPriceReady>
                    {{ dealerPrice(data.code)
                    }}<span class="gst-label" *ngIf="dealerPrice(data.code) && showGstExclusive$ | async">{{
                      'productCarousel.gstExclusive' | cxTranslate
                    }}</span>
                  </ng-template>
                </span>
              </ng-template>
              <ng-template [ngIf]="showSrp">
                <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
                <span class="p-price"
                  >{{ data.srpPrice?.formattedValue
                  }}<span class="gst-label" *ngIf="data.srpPrice?.formattedValue && showGstInclusive$ | async">{{
                    'productCarousel.gstInclusive' | cxTranslate
                  }}</span></span
                >
              </ng-template>
            </span>
            <app-erp-promotional-text
              *ngIf="dealerPrices && !showSrp"
              class="d-xl-block promotional-text"
              [dealerPriceData]="dealerPriceData(data?.code)"
            ></app-erp-promotional-text>
            <app-promotional-text
              *ngIf="!showSrp && dealerPrices"
              [productCode]="data.code"
              [product]="data"
              [dealerPriceData]="dealerPriceData(data.code)"
              [promotionLocation]="'CAROUSEL'"
              [charactersLimit]="40"
            ></app-promotional-text>
          </a>
        </div>
      </div>
    </ngx-slick-carousel>
  </div>
</ng-container>
